export enum TOGGLE_SWITCHER_VARIANT {
  YELLOW = 'yellow',
}
